import { render, staticRenderFns } from "./TherapyAreaCard.vue?vue&type=template&id=abb18744&"
import script from "./TherapyAreaCard.vue?vue&type=script&lang=js&"
export * from "./TherapyAreaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports